export enum ReportFormatEnum {
  'pdf' = 'PDF',
  // 'xls' = 'XLS',
}

export type ReportFormatEnumKeys = keyof typeof ReportFormatEnum
